import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chip", "checkbox", "icon"]

  toggle(event) {
    const chip = event.currentTarget
    const checkbox = chip.querySelector("[data-chip-toggle-target='checkbox']")
    if (!checkbox) return

    checkbox.checked = !checkbox.checked
    this.#applyCheckedStyles(chip, checkbox.checked)
  }

  sync(event) {
    const checkbox = event.currentTarget
    const chip = checkbox.closest("[data-chip-toggle-target='chip']")
    if (!chip) return

    this.#applyCheckedStyles(chip, checkbox.checked)
  }

  #applyCheckedStyles(chip, checked) {
    const icon = chip.querySelector("[data-chip-toggle-target='icon']")

    if (checked) {
      chip.classList.remove("bg-base-100", "border-base-300", "hover:border-primary", "hover:bg-primary/5", "hover:shadow-sm")
      chip.classList.add("bg-primary", "text-primary-content", "border-primary", "shadow-sm")
      if (icon) {
        icon.classList.remove("i-ph-circle-dashed", "text-base-content/40")
        icon.classList.add("i-ph-check-circle")
      }
    } else {
      chip.classList.remove("bg-primary", "text-primary-content", "border-primary", "shadow-sm")
      chip.classList.add("bg-base-100", "border-base-300", "hover:border-primary", "hover:bg-primary/5", "hover:shadow-sm")
      if (icon) {
        icon.classList.remove("i-ph-check-circle")
        icon.classList.add("i-ph-circle-dashed", "text-base-content/40")
      }
    }
  }
}
